var map = {
	"./buffer-graph/buffer-graph.module": [
		"./src/app/buffer-graph/buffer-graph.module.ts"
	],
	"./buffer-table/buffer-table.module": [
		"./src/app/buffer-table/buffer-table.module.ts",
		"common",
		5
	],
	"./change-buffer/change-buffer.module": [
		"./src/app/change-buffer/change-buffer.module.ts",
		"common",
		6
	],
	"./components/access-denied/access-denied.module": [
		"./src/app/components/access-denied/access-denied.module.ts",
		13
	],
	"./components/versions-not-compatible/versions-not-compatible.module": [
		"./src/app/components/versions-not-compatible/versions-not-compatible.module.ts",
		12
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		14
	],
	"./import-assortment/import-assortment.module": [
		"./src/app/import-assortment/import-assortment.module.ts",
		"common",
		8
	],
	"./item-properties/item-properties.module": [
		"./src/app/item-properties/item-properties.module.ts",
		"common",
		4
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		11
	],
	"./manual-orders/manual-orders.module": [
		"./src/app/manual-orders/manual-orders.module.ts",
		"common",
		7
	],
	"./marketing-purchase/marketing-purchase.module": [
		"./src/app/marketing-purchase/marketing-purchase.module.ts",
		"common",
		3
	],
	"./orders/orders.module": [
		"./src/app/orders/orders.module.ts",
		"common",
		0
	],
	"./stocks/stocks.module": [
		"./src/app/stocks/stocks.module.ts",
		"common",
		1
	],
	"./supply-schedules/supply-schedules.module": [
		"./src/app/supply-schedules/supply-schedules.module.ts",
		"common",
		2
	],
	"./test/testing.module": [
		"./src/app/test/testing.module.ts",
		"common",
		10
	],
	"./vacations/vacations.module": [
		"./src/app/vacations/vacations.module.ts",
		"common",
		9
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main